/**
 * Date presentation. GFG is a US company, so everything reads mm/dd/yyyy.
 *
 * A caveat worth knowing before reaching for these: a native `<input type="date">` renders its
 * display format from the BROWSER/OS locale, and no attribute, prop or stylesheet overrides that.
 * `lang` is the only lever — Chrome honours it, Firefox and Safari follow the OS regional setting
 * regardless. So DATE_INPUT_LANG is best-effort on the pickers, while the formatters below are
 * exact everywhere, because we do that rendering ourselves.
 */

/** Applied as `lang` on native date inputs. Chrome uses it to pick the display format. */
export const DATE_INPUT_LANG = "en-US";

/** The locale every displayed date and time is formatted in. */
export const DATE_LOCALE = "en-US";

/** Shown as helper text where the format isn't otherwise obvious. */
export const DATE_FORMAT_HINT = "mm/dd/yyyy";

/** Mirrors the API's BUSINESS_TIMEZONE (apps/gfgf-api/src/constants/date_time.ts) that report date ranges are read in. */
export const BUSINESS_TIMEZONE = "America/New_York";
